import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';

import { PostErrorResponse } from './types';

export type PostGenericEndpointParams<RequestData> = {
	data: RequestData;
	lang?: string;
	token?: string | null;
};

export type PostGenericEndpointResponse<RequestData> =
	PostGenericEndpointParams<RequestData> & {
		path?: string;
	};

const getQueryParams = (lang?: string) => {
	if (typeof window !== 'undefined') {
		const url = new URL(window.location.href);
		url.searchParams.set('culture', lang ?? 'en');

		return url.searchParams.toString();
	}

	return `culture=${lang ?? 'en'}`;
};

export const postGenericEndpoint = async <Request, Response>(
	params: PostGenericEndpointResponse<Request>
): Promise<Response> => {
	const { data, path, lang, token } = params;

	const queryParams = getQueryParams(lang);

	const headers = {
		'Content-Type': 'application/json',
		...(token && { 'X-XSRF-TOKEN': token }),
	};

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/${path}?${queryParams}`, {
		method: 'POST',
		headers: headers,
		body: JSON.stringify(data),
		credentials: 'include',
	})
		.then((response) => {
			if (response.ok)
				return response.json().then((data) => data as Response);

			return response.json().then((error) => {
				throw error as PostErrorResponse;
			});
		})
		.then((success) => success)
		.catch((error: PostErrorResponse) => {
			throw error;
		});
};
